<template>
    <div class="category-section">
        <section-header :title="section.title" icon="fa-folder-open" :count="section.count"/>
        <catalog-course
            class="mb-5"
            :course="course"
            v-for="course in section.courses"
            :key="'course-' + course.id"
            :details="false"
            @enroll="$emit('enroll', $event)"
        />
        <div class="child-section" v-for="child in section.children" :key="'child-' + child.id">
            <h4 class="category-heading">{{ child.title }}<span class="child-count">{{ child.count }}</span></h4>
            <catalog-course
                class="mb-5"
                :course="course"
                v-for="course in child.courses"
                :key="'child-course-' + child.id + '-' + course.id"
                :details="false"
                @enroll="$emit('enroll', $event)"
            />
        </div>
    </div>
</template>

<script>
    import CatalogCourse from "../CatalogCourse";
    import SectionHeader from "../framework/SectionHeader";

    export default {
        name: "CatalogCategorySection",
        components: {CatalogCourse, SectionHeader},
        props: ['section']
    };
</script>

<style lang="scss" scoped>
    .category-section {
        margin-bottom: 2.5rem;

        .child-section {
            margin-left: 1.5rem;

            h4.category-heading {
                font-size: 0.95rem;
                font-weight: bold;
                color: white;
                margin-bottom: 1.25rem;

                .child-count {
                    display: inline-block;
                    margin-left: 0.5rem;
                    padding: 0 0.5rem;
                    border-radius: 999px;
                    background: rgba(255, 255, 255, 0.15);
                    font-size: 0.75rem;
                    font-weight: 600;
                }
            }
        }
    }
</style>
